<script setup lang="ts">
import type { CmsElementImageBanner } from "~/composables/useCustom";
const props = defineProps<{
  content: CmsElementImageBanner;
}>();

const bannerData = props.content?.data || {};
</script>

<template v-if="bannerData">
  <div class="cust-banner h-72 md:h-auto">
    <div class="wrap h-full">
      <figure class="h-full">
        <NuxtImg
          v-if="bannerData.fullBannerImage?.media"
          format="webp"
          :src="bannerData.fullBannerImage?.media.url"
          class="w-full h-full md:h-auto object-cover"
          :alt="bannerData.fullBannerImage?.media.alt"
          loading="lazy"
          :height="bannerData.fullBannerImage?.media.metaData.height"
          :width="bannerData.fullBannerImage?.media.metaData.width"
        />
      </figure>
    </div>
  </div>
</template>

<style scoped>
img {
  /* gradient loader background with animation */
  background: linear-gradient(to right, #f4f3f3, #f1f1f1);
  background-size: 200% 100%;
  animation: gradient-animation 3s ease-in-out infinite;
}

@keyframes gradient-animation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
</style>
